import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Context';
import { AuthContextApi } from '../../Context/api';
import {
    CalendarIcon,
    InformationCircleIcon,
    BuildingStorefrontIcon,
    IdentificationIcon,
    EnvelopeIcon,
    PhoneIcon
} from '@heroicons/react/24/outline'
import { toast } from 'react-toastify';
import CardMetricas from '../../Components/Cards/Metricas';
import Header from '../../Components/Header';
import FormBusca from '../../Components/Forms/Busca';
import { colorMap } from '../../Common';
import ContasRecebimentoTable from '../../Components/Table/ContasRecebimento';
import ModalContasRecebimento from '../../Components/Modal/ContasRecebimento';
import ModalVisualizacaoContasRecebimento from './ModalVisualizacao';
import { jsonConfig } from '../../Config';

const ContasRecebimento = () => {

    const { states, setters } = useContext(AuthContext)
    const {
        checkLogin,
        getContasRecebimento,
        postContasRecebimento,
        patchContasRecebimento,
        deleteContasRecebimento
    } = useContext(AuthContextApi)

    const navigate = useNavigate()
    const [query, setQuery] = useState('')
    const tableScrollRef = useRef(null)
    const tableContainerRef = useRef(null)

    const [showLeftArrow, setShowLeftArrow] = useState(false)
    const [showRightArrow, setShowRightArrow] = useState(true)
    const [arrowTop, setArrowTop] = useState('50%')

    const [searchTerm, setSearchTerm] = useState('')
    const [selectedFilterField, setSelectedFilterField] = useState('nome_empresa')
    const [selectedSortField, setSelectedSortField] = useState('data_criacao')
    const [sortDirection, setSortDirection] = useState('desc')
    const [recordsPerPage, setRecordsPerPage] = useState(10)

    const [modalVisualizacao, setModalVisualizacao] = useState(false)
    const [contaSelecionada, setContaSelecionada] = useState(null)

    const filterOptions = [
        { value: 'nome_empresa', label: 'Nome da Empresa' },
        { value: 'cnpj', label: 'CNPJ' },
        { value: 'email', label: 'E-mail' },
        { value: 'telefone', label: 'Telefone' },
        { value: 'banco', label: 'Banco' },
        { value: 'agencia', label: 'Agência' },
        { value: 'conta', label: 'Conta' },
        { value: 'chave_pix', label: 'Chave PIX' }
    ]

    const sortOptions = [
        { value: 'nome_empresa', label: 'Nome da Empresa' },
        { value: 'chave_pix', label: 'Chave PIX' },
        { value: 'data_criacao', label: 'Data de Criação' }
    ]

    const primeiroLoad = async () => {
        const params = new URLSearchParams({
            page: 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: ''
        })
        await checkLogin()
        await getContasRecebimento(params.toString())
    }

    const loadData = async () => {
        const params = new URLSearchParams({
            page: states.page || 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: searchTerm
        })
    }

    const actionModalContasRecebimentoEdit = async (id, data) => {
        const response = await patchContasRecebimento(id, data)
        if (response) {
            setters.setModalContasRecebimento(false)
            primeiroLoad()
        }
    }

    const actionModalContasRecebimentoCreate = async (data) => {
        const response = await postContasRecebimento(data)
        if (response) {
            setters.setModalContasRecebimento(false)
            primeiroLoad()
        }
    }


    const deleteConta = async (conta) => {
        setters.setModalMsg(true)
        setters.setMsgModalMsg('Excluir Conta de Recebimento')
        setters.setDescModalMsg(`Tem certeza que deseja excluir a conta da empresa "${conta.nome_empresa}"? Esta ação não pode ser desfeita.`)
        setters.setPerigoModalMsg(true)
        setters.setTitleButtonModalMsg('Excluir')
        setters.setFunctionModalMsg(() => async () => {
            setters.setModalMsg(false)
            const resp = await deleteContasRecebimento(conta.id)
            if (resp) {
                primeiroLoad()
            }
            setters.setModalMsg(false)
        })
    }

    const next = async () => {
        setters.setPage(states.page + 1)
    }

    const previous = async () => {
        if (states.page > 0) {
            setters.setPage(states.page - 1)
        }
    }

    const search = async (data) => {
        const params = new URLSearchParams({
            page: states.page || 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: selectedFilterField,
            search: searchTerm
        })
        await getContasRecebimento(params.toString())
    }

    const clear = async () => {
        setters.setPage(0)
        const params = new URLSearchParams({
            page: 0,
            per_page: 10,
            sort: 'data_criacao',
            sort_dir: 'desc',
            filter: 'nome_empresa',
            search: ''
        })
        await getContasRecebimento(params.toString())
    }

    const color = 'orange'
    const colorClasses = colorMap[color] || colorMap.orange

    const userPermission = localStorage.getItem('permisssion')
    const isAdmin = userPermission === jsonConfig.roles.admin

    const addConta = () => {
        setters.setIsEdit(false)
        setters.setContasRecebimento({})
        setters.setModalContasRecebimento(true)
    }

    const editConta = (conta) => {
        setters.setIsEdit(true)
        setters.setContasRecebimento(conta)
        setters.setModalContasRecebimento(true)
    }

    const viewConta = (conta) => {
        setContaSelecionada(conta)
        setModalVisualizacao(true)
    }


    const checkScrollPosition = () => {
        if (tableScrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = tableScrollRef.current
            const isAtStart = scrollLeft <= 1
            const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1
            setShowLeftArrow(!isAtStart)
            setShowRightArrow(!isAtEnd)
        }
    }

    const calculateArrowPosition = () => {
        if (tableContainerRef.current && tableScrollRef.current) {
            const containerRect = tableContainerRef.current.getBoundingClientRect()
            const scrollRect = tableScrollRef.current.getBoundingClientRect()
            const headerHeight = scrollRect.top - containerRect.top
            const tableHeight = scrollRect.height
            const topPosition = headerHeight + (tableHeight / 2)
            const containerHeight = containerRect.height
            const percentage = (topPosition / containerHeight) * 100
            setArrowTop(`${percentage}%`)
        }
    }

    const headers = [
        {
            label: 'Ações',
            icon: BuildingStorefrontIcon,
            key: 'actions'
        },
        {
            label: 'Empresa',
            icon: InformationCircleIcon,
            key: 'nome_empresa'
        },
        {
            label: 'CNPJ',
            icon: IdentificationIcon,
            key: 'cnpj'
        },
        {
            label: 'Banco',
            icon: BuildingStorefrontIcon,
            key: 'banco'
        },
        {
            label: 'Agência',
            icon: InformationCircleIcon,
            key: 'agencia'
        },
        {
            label: 'Conta',
            icon: InformationCircleIcon,
            key: 'conta'
        },
        {
            label: 'Chave PIX',
            icon: InformationCircleIcon,
            key: 'chave_pix'
        },
        {
            label: 'Criação',
            icon: CalendarIcon,
            key: 'data_criacao'
        }
    ]

    useEffect(() => {
        const tableElement = tableScrollRef.current
        if (tableElement) {
            const timer = setTimeout(() => {
                checkScrollPosition()
                calculateArrowPosition()
            }, 1)

            tableElement.addEventListener('scroll', checkScrollPosition)
            window.addEventListener('resize', () => {
                checkScrollPosition()
                calculateArrowPosition()
            })

            return () => {
                clearTimeout(timer)
                tableElement.removeEventListener('scroll', checkScrollPosition)
                window.removeEventListener('resize', checkScrollPosition)
            }
        }
    }, [states.dataContasRecebimento, states.loading])


    // const [dataContasRecebimento, setDataContasRecebimento] = useState([])
    // const [ContasRecebimento, setContasRecebimento] = useState({})
    // const [modalContasRecebimento, setModalContasRecebimento] = useState(false)
    // const [isEditContasRecebimento, setIsEditContasRecebimento] = useState(false)

    useEffect(() => {
        if (states.dataContasRecebimento.length > 0) {
            search()
        }
    }, [states.page])


    useEffect(() => {
        primeiroLoad()

        return () => {
            setQuery('')
            setters.setDataContasRecebimento([])
            setters.setContasRecebimento({})
            setters.setModalContasRecebimento(false)
            setters.setIsEditContasRecebimento(false)
        }
    }, [])

    return (
        <>
            <Header
                title="Contas de Recebimento"
                description="Gerencie contas de recebimento do sistema"
                icon={BuildingStorefrontIcon}
                buttonText="Adicionar Conta"
                buttonAction={addConta}
                hasAction={true}
                hasReturn={false}
                color='orange'
            />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {isAdmin && <CardMetricas dataMetricas={null} color={color} />}
                <FormBusca
                    filterOptions={filterOptions}
                    sortOptions={sortOptions}
                    search={search}
                    handleClear={clear}
                    color={color}
                    items={{
                        searchTerm,
                        setSearchTerm,
                        selectedFilterField,
                        setSelectedFilterField,
                        selectedSortField,
                        setSelectedSortField,
                        sortDirection,
                        setSortDirection,
                        recordsPerPage,
                        setRecordsPerPage,
                    }}
                    haveData={states.dataContasRecebimento.length > 0}
                />

                <ContasRecebimentoTable
                    data={states.dataContasRecebimento}
                    loading={states.loading}
                    title="Contas de Recebimento"
                    headers={headers}
                    viewConta={viewConta}
                    editConta={editConta}
                    deleteConta={deleteConta}
                    color={color}
                    previous={previous}
                    next={next}
                    page={states.page}
                    isAdmin={isAdmin}
                />
            </div>

            <ModalContasRecebimento
                states={states}
                setters={setters}
                actionCreate={actionModalContasRecebimentoCreate}
                actionEdit={actionModalContasRecebimentoEdit}
                color={color}
            />

            <ModalVisualizacaoContasRecebimento
                isOpen={modalVisualizacao}
                onClose={() => setModalVisualizacao(false)}
                conta={contaSelecionada}
                color={color}
            />
        </>
    )
}

export default ContasRecebimento;
